import React, { Fragment, useState, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import UserPanel from "./userPanel";
import { MENUITEMS } from "./menu";
import { Link, NavLink } from "react-router-dom";
import { translate } from "react-switch-lang";
import styled from "styled-components";
import configDB from "../../../data/customizer/config";
import "./style.css";
import SearchHeader from "../header-component/searchHeader";
import Config from "../../../config/index";

const Sidebar = (props) => {
  const mixLayout = useSelector((state) => state?.Customizer?.mix_layout);
  const [margin, setMargin] = useState(0);
  const [iconWidth, seticonWidth] = useState(20);
  const [width, setWidth] = useState(0);
  const [hideLeftArrowRTL, setHideLeftArrowRTL] = useState(true);
  const [hideRightArrowRTL, setHideRightArrowRTL] = useState(true);
  const [features, setFeatures] = useState([]);
  const [hideRightArrow, setHideRightArrow] = useState(true);
  const [hideLeftArrow, setHideLeftArrow] = useState(true);
  const [mainmenu, setMainMenu] = useState(MENUITEMS);
  const [activeParent, setActiveParent] = useState("");
  const [activeChild, setActiveChild] = useState("");
  const wrapper = configDB.data.settings.sidebar.wrapper;
  const layout = useSelector((content) => content.Customizer.layout);
  //const [menuFeature,setMenuFeature]=useState(JSON.parse(sessionStorage.getItem("features"))[0].children)

  const [sidebar, setSidebar] = useState(false);
  const [screen, setScreen] = useState();
  const [checkVisible, setCheckVisible] = useState("")


  // Selector STARTS
  // const features = useSelector((data) => data.Features).features;
  // Selector ENDS
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    var currentUrl = window.location.pathname;
    let menuFeature = JSON.parse(sessionStorage.getItem("features"))[0]
      .children;

    let activeMenu = [...MENUITEMS]; //MENUITEMS.filter(item=>{return (menuFeature.some((item2=>item2.feature.toLowerCase() == item.title.toLowerCase() || item.title.toLowerCase().includes(item2.feature.toLowerCase()))))})

    activeMenu.map((item, index) => {
      if (item.title != "Dashboard") {
        let allChild = [];

        for (let i = 0; i < menuFeature.length; i++) {
          let children = item?.children?.filter((ch) => {
            return menuFeature[i].children.some((ch2) => {
              return ch.title == "Shareholding" && "Shareholders" == ch2.label
                ? true
                : ch.title == "Categories of Holders" &&
                  "Category of Shareholding" == ch2.label
                  ? true
                  : ch.title == "List of Shareholding" &&
                    ch2.label == "List of Shareholders"
                    ? true
                    : ch.title == "List of Shareholding" &&
                      ch2.label == "List of Shareholders"
                      ? true
                      : // : ch.title == "Comany Data" && ch2.label == "Companies"
                      ch.title == "Company Info" && ch2.label == "Companies"
                        ? true // added company data
                        : ch2.label.toLowerCase() ==
                        ch.title.replace(/s$/, "").toLowerCase() ||
                        ch2.label.toLowerCase() == ch.title.toLowerCase() ||
                        (item.title != "Shareholdings" &&
                          item.title != "Governance" &&
                          ch2.label
                            .toLowerCase()
                            .includes(ch.title.replace(/s$/, "").toLowerCase()));
            });
          });

          if (children.length > 0) {
            allChild = allChild.concat(children);
          }
        }
        activeMenu[index].children = allChild;
      }
    });
    activeMenu = activeMenu.filter(
      (item) => item.children?.length > 0 || item.title == "Dashboard"
    );
    activeMenu = activeMenu.map((item) => {
      if (item.title === "Governance") {
        item.children = item.children.map((ch) => {
          if (ch.title === "Dashboard Governance") {
            ch.title = "Dashboard";
          }
          return ch;
        });
      }
      if (item.title === "Corporate Actions") {
        let temp = item.children.shift();
        item.children.push(temp);
      }
      if (item.title === "Transactions") {
        let temp = item.children.pop();
        item.children.unshift(temp);
      }
      return item;
    });
    setFeatures([...activeMenu]);
    features?.length > 0 &&
      features.filter((items) => {
        if (items.path === currentUrl) setNavActive(items);
        if (!items.children) return false;

        items.children.filter((subItems) => {
          if (subItems.path === currentUrl) setNavActive(subItems);
          if (!subItems.children) return false;

          subItems.children.filter((subSubItems) => {
            if (subSubItems.path === currentUrl) {
              setNavActive(subSubItems);
              return true;
            } else {
              return false;
            }
          });
          return subItems;
        });
        return items;
      });

    const timeout = setTimeout(() => {
      const elmnt = document.getElementById("myDIV");
      const menuWidth = elmnt.offsetWidth;
      if (menuWidth > window.innerWidth) {
        setHideRightArrow(false);
        setHideLeftArrowRTL(false);
        seticonWidth(60);
      } else {
        setHideRightArrow(true);
        setHideLeftArrowRTL(true);
        seticonWidth(20);
      }
    }, 500);

    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    setActiveChild(sessionStorage.getItem("Active_Child"));
    if (window.location.href?.includes("/admindashboard")) {
      setActiveParent("Dashboard");
      setActiveChild("");
    } else if (window.location.href?.includes("/company-listing")) {
      setActiveParent("Company");
    }
    // else if (
    //   window.location.href?.includes("/investors-listing") ||
    //   window.location.href?.includes("/investor-request-listing")
    // ) {
    //   setActiveParent("Investors")
    // }
    else if (
      window.location.href?.includes("/shareholder-listing") ||
      window.location.href?.includes("/category-of-shareholding") ||
      window.location.href?.includes("/pattern-holding") ||
      window.location.href?.includes("/free-float-report") ||
      window.location.href?.includes("/shareholding-history") ||
      window.location.href?.includes("/list-of-shareholders")
    ) {
      setActiveParent("Shareholdings");
    } else if (
      window.location.href?.includes("/investors-request-report") ||
      window.location.href?.includes("/transaction-listing") ||
      window.location.href?.includes("/inprocess-transactions")
    ) {
      setActiveParent("Transactions");
    } else if (
      window.location.href?.includes("/statutory-events")
      // window.location.href?.includes("/statutory-requirements-listing") ||
      // window.location.href?.includes("/statutory-events")
    ) {
      setActiveParent("Statutory");
    } else if (
      window.location.href?.includes("/evoting-dashboard") ||
      window.location.href?.includes("/elections-of-directors-listing") ||
      window.location.href?.includes("/candidates-listing") ||
      window.location.href?.includes("/election-voting") ||
      window.location.href?.includes("/election-voting-report") ||
      // window.location.href?.includes("/compile-elections-results") ||
      // window.location.href?.includes("/proxy-listing") ||
      // window.location.href?.includes("/authorization-listing") ||
      window.location.href?.includes("/special-resolution-listing") ||
      window.location.href?.includes("/special-voting") ||
      window.location.href?.includes("/special-voting-report") ||
      // window.location.href?.includes("/compile-resolution-results") ||
      // window.location.href?.includes("/evoting-intimation-letters") ||
      window.location.href?.includes("/voting-attendance")
    ) {
      setActiveParent("Governance");
    } else if (
      window.location.href?.includes("/corporate-action-calculator") ||
      window.location.href?.includes("/corporate-announcement-listing") ||
      window.location.href?.includes("/corporate-entitlement-listing") ||
      window.location.href?.includes("/right-allotment-report") ||
      window.location.href?.includes("/bonus-allotment-report") ||
      window.location.href?.includes("/dividend-allotment-report") ||
      window.location.href?.includes("/disbursement-listing")
      // window.location.href?.includes("/corporate-entitlement-uploader") ||
      // window.location.href?.includes("/bank-deposit-uploader") ||
      // window.location.href?.includes("/intimation-letter") ||
      // window.location.href?.includes("/right-credit")
    ) {
      setActiveParent("Corporate Actions");
    }
    // else if (
    //   window.location.href?.includes("/disbursement-listing") ||
    //   window.location.href?.includes("/disbursement-uploader") ||
    //   window.location.href?.includes("/dividend-payment") ||
    //   window.location.href?.includes("/dividend-disbursement-recon") ||
    //   window.location.href?.includes("/processed-dividend-disbursements")
    // ) {
    //   setActiveParent("Dividend  Disbursement")
    // }

    // else if (
    //   window.location.href?.includes("/public-offering-dashboard") ||
    //   window.location.href?.includes("/ipo-offering") ||
    //   window.location.href?.includes("/ipo-subscription-uploader") ||
    //   window.location.href?.includes("/ipo-subscriptions") ||
    //   window.location.href?.includes("/ipo-payment-reconciliation") ||
    //   window.location.href?.includes("/ipo-failed-payments") ||
    //   window.location.href?.includes("/ipo-subscription-report") ||
    //   window.location.href?.includes("/ipo-allotment") ||
    //   window.location.href?.includes("/ipo-allotment-report")
    // ) {
    //   setActiveParent("Public Offerings")
    // }
    // else if (
    //   window.location.href?.includes("/shareholding-history") ||
    //   window.location.href?.includes("/shareholding-pattern") ||
    //   window.location.href?.includes("/category-of-shareholding") ||
    //   window.location.href?.includes("/list-of-shareholders") ||
    //   window.location.href?.includes("/shareholding-statement") ||
    //   window.location.href?.includes("/free-float-report") ||
    //   window.location.href?.includes("/right-allotment-report") ||
    //   window.location.href?.includes("/bonus-allotment-report") ||
    //   window.location.href?.includes("/dividend-allotment-report") ||
    //   window.location.href?.includes("/investors-request-report") ||
    //   window.location.href?.includes("/tos-report") ||
    //   window.location.href?.includes("/label-printing")
    // ) {
    //   setActiveParent("Reporting")
    // }
    else {
      setActiveParent("");
    }
  }, [window.location.href]);

  const handleResize = () => {
    setWidth(window.innerWidth - 310);
  };

  const setNavActive = (item) => {
    features &&
      features.filter((menuItem) => {
        if (menuItem !== item) menuItem.active = false;
        if (menuItem.children && menuItem.children.includes(item))
          menuItem.active = true;
        if (menuItem.children) {
          menuItem.children.filter((submenuItems) => {
            if (submenuItems.children && submenuItems.children.includes(item)) {
              menuItem.active = true;
              submenuItems.active = true;
              return true;
            } else {
              return false;
            }
          });
        }
        return menuItem;
      });
    item.active = !item.active;
    setMainMenu({ mainmenu: features });
  };

  // Click Toggle menu
  const toggletNavActive = (item) => {
    setActiveParent("");
    if (localStorage.getItem("wrapper") === "horizontal_sidebar") {
      features.forEach((a) => {
        if (a.title == item.title) {
          setActiveParent(a.title)
        }
        if (!a.children) return false;
        a.children.forEach((b) => {
          if (a.children.includes(item)) {
            b.active = true;
            setActiveParent(a.title)
          }
          if (!b.children) return false;
          b.children.forEach((c) => {
            if (b.children.includes(item)) {
              c.active = true;
              setActiveParent(a.title)
            }
          });
        });
      });
    }
    if (!item.active) {
      features.forEach((a) => {
        if (features.includes(item)) a.active = false;
        if (!a.children) return false;
        a.children.forEach((b) => {
          if (a.children.includes(item)) {
            b.active = false;
          }
          if (!b.children) return false;
          b.children.forEach((c) => {
            if (b.children.includes(item)) {
              c.active = false;
            }
          });
        });
      });
    }
    item.active = !item.active;
    setMainMenu({ mainmenu: features });
  };

  const scrollToRight = () => {
    const elmnt = document.getElementById("myDIV");
    const menuWidth = elmnt.offsetWidth;
    const temp = menuWidth + margin;
    if (temp < menuWidth) {
      setMargin(-temp);
      setHideRightArrow(true);
    } else {
      setMargin((margin) => (margin += -width));
      setHideLeftArrow(false);
    }
  };

  const scrollToLeft = () => {
    // If Margin is reach between screen resolution
    if (margin >= -width) {
      setMargin(0);
      setHideLeftArrow(true);
    } else {
      setMargin((margin) => (margin += width));
      setHideRightArrow(false);
    }
  };

  const scrollToLeftRTL = () => {
    if (margin <= -width) {
      setMargin((margin) => (margin += -width));
      setHideLeftArrowRTL(true);
    } else {
      setMargin((margin) => (margin += -width));
      setHideRightArrowRTL(false);
    }
  };

  const scrollToRightRTL = () => {
    const temp = width + margin;
    // Checking condition for remaing margin
    if (temp === 0) {
      setMargin(temp);
      setHideRightArrowRTL(true);
    } else {
      setMargin((margin) => (margin += width));
      setHideRightArrowRTL(false);
      setHideLeftArrowRTL(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setScreen(window?.outerWidth);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const closeSideBarOnMenuChange = () => {
    if (document.documentElement.clientWidth <= 768) {
      document.querySelector(".page-main-header").classList.toggle("open");
      document.querySelector(".page-sidebar").classList.toggle("open");
      // sessionStorage.setItem('menu_tab',true);
      // sessionStorage.removeItem("menu");
    }
  };
  const layoutWrapper = localStorage.getItem("wrapper");
  const searchStyleText =
    mixLayout == "light-only" || mixLayout == "dark-body-only"
      ? ""
      : "hsla(0,0%,100%,.85)";
  const activeParentStyle =
    mixLayout == "light-only" || mixLayout == "dark-body-only"
      ? "black"
      : "#ffffff";
  const dividerForSelectedItems = {
    margin: "2px",
    borderColor: activeParentStyle,
    position: "absolute",
    width: "67%",
    left: "46%",
    top: "50%",
    transform: "translate(-50%, 10px)",
  };

  return (
    <Fragment>
      {/* <WrapperSidebar> */}
      <div
        className={
          layoutWrapper === "compact-page"
            ? "page-sidebar WrapperHoverSidebar"
            : "page-sidebar"
        }
      >
        <div className="main-header-left d-none">
          <div className="logo-wrapper justify-content-center">
            <NavLink
              to={`${process.env.PUBLIC_URL}/admindashboard`}
              className="mt-4"
            >
              {/* <img className="blur-up lazyloaded" src={logo_compact} alt="" />
                            <img className="blur-up lazyloaded" src={logo} alt="" /> */}
              {/* <img className="blur-up lazyloaded" width="100" src={logo} alt="" /> */}
              {/* <center className="text-center">
                <img
                  id="sidebar-image"
                  src={logo}
                  width="100"
                  alt=""
                  className="my-2"
                />
              </center> */}
            </NavLink>
          </div>
        </div>
        {localStorage.getItem("wrapper") === "horizontal_sidebar" && (
          <SearchHeader />
        )}
        <div
          style={{
            height: layoutWrapper === "compact-wrapper" ? "100vh" : "",
          }}
          className="sidebar custom-scrollbar"
        >
          <UserPanel />
          {localStorage.getItem("wrapper") !== "horizontal_sidebar" && (
            <SearchHeader />
          )}
          <ul
            className="sidebar-menu"
            id="myDIV"
            style={
              wrapper === "horizontal_sidebar"
                ? layout === "rtl"
                  ? { marginRight: margin + "px" }
                  : { marginLeft: margin + "px" }
                : { margin: "0px" }
            }
          >
            <li
              className={`left-arrow ${layout === "rtl"
                ? hideLeftArrowRTL
                  ? "d-none"
                  : ""
                : hideLeftArrow
                  ? "d-none"
                  : ""
                }`}
              onClick={
                wrapper === "horizontal_sidebar" && layout === "rtl"
                  ? scrollToLeftRTL
                  : scrollToLeft
              }
            >
              <i className="fa fa-angle-left"></i>
            </li>
            {features?.length > 0 &&
              features.map((menuItem, i) => (
                <li
                  onMouseEnter={() => {
                    (localStorage.getItem("wrapper") == "horizontal_sidebar" || localStorage.getItem("wrapper") == "compact-wrapper") && setCheckVisible(menuItem.title)
                  }}
                  onMouseLeave={() => {
                    (localStorage.getItem("wrapper") == "horizontal_sidebar" || localStorage.getItem("wrapper") == "compact-wrapper") && setCheckVisible("")
                  }}
                  style={{
                    padding: localStorage.getItem("wrapper") === "compact-wrapper" ? "0px 3px" : ""
                  }}
                  className={`${menuItem.active ? "active" : ""}`} key={i}>
                  {menuItem.sidebartitle ? (
                    <div className="sidebar-title ">
                      {menuItem.sidebartitle}
                    </div>
                  ) : (
                    ""
                  )}
                  {menuItem.type === "sub" ? (
                    <div
                      className="sidebar-header"
                      onClick={() => {
                        features.forEach((a) => {
                          if (!a.children) return false;
                          a.children.forEach((b) => {
                            b.active = false;
                            if (!b.children) return false;
                            b.children.forEach((c) => {
                              c.active = false;
                            });
                          });
                        });
                        toggletNavActive(menuItem);
                      }}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <i
                        className={
                          layoutWrapper === "compact-wrapper"
                            ? menuItem.classname.replaceAll('"', "") + " ml-3"
                            : menuItem.classname.replaceAll('"', "")
                        }
                      ></i>
                      <span className="position-relative">
                        {menuItem.title}
                        {(layoutWrapper === "compact-wrapper" ||
                          layoutWrapper === "horizontal_sidebar") && (
                            <i
                              style={{
                                fontSize: "17px",
                                marginTop:
                                  layoutWrapper === "horizontal_sidebar" && "2px",
                              }}
                              className={`${(localStorage.getItem("wrapper") !==
                                "horizontal_sidebar" && menuItem.active) || (checkVisible == menuItem.title)
                                ? "fa fa-angle-down pull-right"
                                : "fa fa-angle-right pull-right"
                                }`}
                            ></i>
                          )}
                        {((localStorage.getItem("wrapper") !==
                          "horizontal_sidebar" &&
                          menuItem.active) ||
                          activeParent == menuItem.title) && (
                            <hr style={dividerForSelectedItems}></hr>
                          )}
                      </span>
                      {(layoutWrapper === "default" ||
                        layoutWrapper === "compact-page") && (
                          <i
                            className={`${localStorage.getItem("wrapper") !==
                              "horizontal_sidebar" && menuItem.active
                              ? "fa fa-angle-down pull-right"
                              : "fa fa-angle-right pull-right"
                              }`}
                          ></i>
                        )}
                    </div>
                  ) : (
                    ""
                  )}
                  {menuItem.type === "link" ? (
                    <Link
                      to={`${process.env.PUBLIC_URL}${menuItem.path}`}
                      className={`sidebar-header ${menuItem.active ? "active" : ""
                        }`}
                      onClick={() => {
                        closeSideBarOnMenuChange();
                        toggletNavActive(menuItem);
                      }}
                    >
                      <i
                        className={
                          layoutWrapper === "compact-page"
                            ? menuItem.classname + " test"
                            : layoutWrapper === "compact-wrapper"
                              ? menuItem.classname + " HomeIcon"
                              : menuItem.classname
                        }
                      ></i>
                      <span
                        style={{
                          position: "relative",
                        }}
                        // style={{
                        //   fontFamily: "Montserrat, sans-serif",
                        // }}
                        className={
                          layoutWrapper === "compact-page" ? "test" : ""
                        }
                      >
                        {props.t(menuItem.title)}
                        {((localStorage.getItem("wrapper") !==
                          "horizontal_sidebar" &&
                          menuItem.active) ||
                          activeParent == menuItem.title) && (
                            <hr style={dividerForSelectedItems}></hr>
                          )}
                      </span>
                      {menuItem.children ? (
                        <i className="fa fa-angle-right pull-right"></i>
                      ) : (
                        ""
                      )}
                    </Link>
                  ) : (
                    ""
                  )}
                  {menuItem.children ? (
                    <ul
                      onMouseEnter={() => {
                        (localStorage.getItem("wrapper") == "horizontal_sidebar") && setCheckVisible(menuItem.title)
                      }}
                      onMouseLeave={() => {
                        (localStorage.getItem("wrapper") == "horizontal_sidebar") && setCheckVisible("")
                      }}
                      className={`sidebar-submenu${menuItem.active ? " menu-open" : ""
                        }`}
                      style={
                        menuItem.active
                          ? { opacity: 1, transition: "opacity 500ms ease-in" }
                          : {}
                      }
                    >
                      {menuItem.children.map((childrenItem, index) => (
                        <li
                          key={index}
                          className={
                            childrenItem.children
                              ? childrenItem.active
                                ? "active"
                                : ""
                              : ""
                          }
                        >
                          {childrenItem.type === "sub" ? (
                            <a
                              href="#javascript"
                              onClick={() => toggletNavActive(childrenItem)}
                            >
                              <i className="fa fa-circle"></i>
                              {props.t(childrenItem.title)}
                              <i className="fa fa-angle-right pull-right"></i>
                            </a>
                          ) : (
                            ""
                          )}

                          {childrenItem.type === "link" ? (
                            <Link
                              to={`${process.env.PUBLIC_URL}${childrenItem.path}`}
                              className={
                                childrenItem.active ||
                                  activeChild == childrenItem?.title
                                  ? "active"
                                  : ""
                              }
                              onClick={() => {
                                sessionStorage.setItem(
                                  "Active_Child",
                                  childrenItem.title
                                );
                                closeSideBarOnMenuChange();
                                toggletNavActive(childrenItem);
                              }}
                            >
                              <i style={{ color: (activeChild && localStorage.getItem("wrapper") == "horizontal_sidebar") == childrenItem?.label ? "black" : "" }} className="fa fa-circle"></i>
                              <span
                                style={{
                                  color: localStorage.getItem("wrapper") == "horizontal_sidebar" && activeChild == childrenItem?.title ? "black" : ""
                                }}
                              >
                                {props.t(
                                  childrenItem.title === "Action Calculator"
                                    ? "Action Simulator"
                                    : childrenItem.title
                                )}
                              </span>
                            </Link>
                          ) : (
                            ""
                          )}
                          {childrenItem.children ? (
                            <ul
                              className={`sidebar-submenu ${childrenItem.active ? "menu-open" : "active"
                                }`}
                            >
                              {childrenItem.children.map(
                                (childrenSubItem, key) => (
                                  <li
                                    className={
                                      childrenSubItem.active ? "active" : ""
                                    }
                                    key={key}
                                  >
                                    {childrenSubItem.type === "link" ? (
                                      <Link
                                        to={`${process.env.PUBLIC_URL}${childrenSubItem.path}`}
                                        className={
                                          childrenSubItem.active ? "active" : ""
                                        }
                                        onClick={() =>
                                          toggletNavActive(childrenSubItem)
                                        }
                                      >
                                        <i className="fa fa-circle"></i>
                                        <span
                                        // style={{
                                        //   fontFamily:
                                        //     "Montserrat, sans-serif",
                                        // }}
                                        >
                                          {props.t(childrenSubItem.title)}
                                        </span>
                                      </Link>
                                    ) : (
                                      ""
                                    )}
                                  </li>
                                )
                              )}
                            </ul>
                          ) : (
                            ""
                          )}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    ""
                  )}
                </li>
              ))}
            <li
              className={`right-arrow ${layout === "rtl"
                ? hideRightArrowRTL
                  ? "d-none"
                  : ""
                : hideRightArrow
                  ? "d-none"
                  : ""
                }`}
              onClick={
                wrapper === "horizontal_sidebar" && layout === "rtl"
                  ? scrollToRightRTL
                  : scrollToRight
              }
            >
              <i className="fa fa-angle-right"></i>
            </li>
          </ul>
          {localStorage.getItem("wrapper") === "compact-wrapper" &&
            <div
              className={"border-top pt-5 pb-2 d-flex justify-content-center"}
            >
              <p style={{ color: searchStyleText }} className="mb-0 pl-3">
                {"Digital Custodian"}
                <i className="fa fa-heart ml-3"></i> {Config.appVersion}
              </p>
            </div>}
        </div>
        <div
          className={
            localStorage.getItem("wrapper") === "horizontal_sidebar"
              ? "py-2 border-top col-md-12 d-flex justify-content-center"
              : "pt-4 border-top col-md-12 d-flex justify-content-center"
          }
        >
          <p style={{ color: searchStyleText }} className="pull-right mb-0">
            {"Digital Custodian"}
            <i className="fa fa-heart ml-2"></i> {Config.appVersion}
          </p>
        </div>
      </div>
      {/* </WrapperSidebar> */}
    </Fragment>
  );
};
export default translate(Sidebar);

// export default translate(Sidebar);
